"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = exports.LOGOUT = void 0;
var LOGOUT;
(function (LOGOUT) {
    LOGOUT["ACTION"] = "LOGOUT_ACTION";
})(LOGOUT = exports.LOGOUT || (exports.LOGOUT = {}));
var logout = function () { return ({
    type: LOGOUT.ACTION,
}); };
exports.logout = logout;
//# sourceMappingURL=logout.js.map